import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

function ScrollToTop({ children }) {
  const location = useLocation();
  const navigationType = useNavigationType();
  const mounted = useRef(false);

  useEffect(() => {
    if (
      mounted.current &&
      navigationType === "REPLACE" &&
      location.state?.preserveScroll
    )
      return;
    const reducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const behavior =
      mounted.current &&
      navigationType !== "POP" &&
      (navigationType === "PUSH" || location.state?.scrollTransition) &&
      !reducedMotion
        ? "smooth"
        : "auto";
    mounted.current = true;
    const target = document.getElementById(location.hash.slice(1));
    if (target) {
      target.scrollIntoView({ behavior, block: "start" });
      const heading = target.querySelector("h1, h2");
      (heading || target).focus({ preventScroll: true });
    } else {
      window.scrollTo({ top: 0, behavior });
    }
  }, [location, navigationType]);

  return <>{children}</>;
}

export default ScrollToTop;
